<template>
    <div>
        <div class="tabs_content">
            <ul>
                <li class="active">我的账号</li>
                <li @click="orderjump(2)">地址管理</li>
                <li @click="orderjump(3)">我的优惠券</li>
            </ul>
        </div>
        <div class="accounts_main">
            <Form ref="accountsform" :model="accountsform" :rules="accountsrule" :label-width="110" :show-message="false">
                <Row>
                    <Col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
                        <div class="homepage_module_content">
                            <div class="homepage_module_head">
                                <div class="homepage_module_head_left"><h3>我的账号</h3></div>
                            </div>
                            <div class="accounts_list">
                                <FormItem label="登录帐号" prop="accounts">
                                    <div class="accounts_txt">
                                        <span>{{accountsform.account}}</span><a href="javascript:;" @click="reviseClick">修改密码</a>
                                    </div>
                                </FormItem>
                                <FormItem label="联系人" prop="linkman">
                                    <Input v-model="accountsform.linkman" placeholder="请输入联系人姓名" style="width: 188px"></Input>
                                </FormItem>
                                <FormItem label="电话号码" prop="contactphone">
                                    <Input v-model="accountsform.contactphone" placeholder="请输入电话号码" :maxlength="11" @on-change="countactphoneChange" style="width: 188px"></Input>
                                </FormItem>
                                <FormItem label="邮箱" prop="email">
                                    <Input v-model="accountsform.email" type="email" placeholder="请输入常用邮箱" style="max-width: 188px"></Input>
                                </FormItem>
                            </div>
                        </div>
                        <div class="homepage_module_content">
                            <div class="homepage_module_head">
                                <div class="homepage_module_head_left"><h3>公司信息</h3></div>
                            </div>
                            <div class="accounts_list">
                                <FormItem label="公司名称" prop="name">
                                    <div class="accounts_txt">
                                        <span>{{accountsform.name}}</span>
                                    </div>
                                </FormItem>
                                <FormItem label="所在地区" prop="city">
                                    <div class="accounts_txt">
                                        <span>{{accountsform.city == '' ? '如需修改，请联系客服' : accountsform.city}}</span>
                                    </div>
                                </FormItem>
                                <FormItem label="详细地址" prop="addressdet">
                                    <Input v-model="accountsform.addressdet" placeholder="请输入详细地址" style="max-width: 290px"></Input>
                                </FormItem>
                            </div>
                        </div>
                    </Col>
                    <Col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
                        <div class="homepage_module_content">
                            <div class="homepage_module_head">
                                <div class="homepage_module_head_left"><h3>发票信息</h3></div>
                            </div>
                            <div class="accounts_list">
                                <FormItem label="发票抬头" prop="billtitle">
                                    <Input v-model="accountsform.billtitle" placeholder="请输入发票抬头"></Input>
                                </FormItem>
                                <FormItem label="纳税人识别号" prop="billnumber">
                                    <Input v-model="accountsform.billnumber" placeholder="请输入纳税人识别号"></Input>
                                </FormItem>
                                <FormItem label="注册地址" prop="regaddress">
                                    <Input v-model="accountsform.regaddress" placeholder="请输入注册地址"></Input>
                                </FormItem>
                                <FormItem label="注册电话" prop="regphone">
                                    <Input v-model="accountsform.regphone" placeholder="请输入注册电话"></Input>
                                </FormItem>
                                <FormItem label="开户银行" prop="bankname">
                                    <Input v-model="accountsform.bankname" placeholder="请输入开户银行"></Input>
                                </FormItem>
                                <FormItem label="银行账号" prop="banknumber">
                                    <Input v-model="accountsform.banknumber" placeholder="请输入银行账号"></Input>
                                </FormItem>
                            </div>
                        </div>
                        <div class="confirm_btn_content">
                            <Button type="warning" @click="confirmClick">确定</Button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </div>
        <!-- 修改密码弹窗 -->
        <Modal
            class="agreement_content"
            v-model="pwdmodal"
            :width="560"
            :scrollable="false">
            <div slot="header" class="model_head">
            <span>修改密码</span>
            </div>
            <div class="model_body">
            <div class="revisepwd_content">
                <Form ref="revisepwdform" :model="revisepwdform" :rules="revisepwdrule" :label-width="80">
                    <FormItem label="账号" prop="account">
                        <Input v-model="revisepwdform.account" placeholder="帐号" :disabled="true"></Input>
                    </FormItem>
                    <FormItem label="验证码" prop="verification">
                        <div class="revisepwd_verification">
                            <Input v-model="revisepwdform.verification" placeholder="请输入验证码"></Input>
                            <Button :disabled="pwddisabled" type="warning" @click="verificationbtn">{{pwdtxt}}</Button>
                        </div>
                    </FormItem>
                    <FormItem label="新密码" prop="password">
                        <Input type="password" v-model="revisepwdform.password" :minlength="6" :maxlength="20" placeholder="请设置新密码6-20位英文、数字、符号"></Input>
                    </FormItem>
                    <FormItem label="确认密码" prop="passwords">
                        <Input type="password" v-model="revisepwdform.passwords" :minlength="6" :maxlength="20" placeholder="请再次确认密码"></Input>
                    </FormItem>
                </Form>
            </div>
            </div>
            <div slot="footer">
                <Button type="warning" @click="pwdOk">提交</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import api from '@/request/api.js'
export default {
    data() {
        const passwordPass = (rule, value, callback) => {
            var reg = new RegExp("[\\u4E00-\\u9FFF]+","g")
            if (value === '' || value.length < 6 || value.length > 20 || reg.test(value)) {
                if (value === '') {
                    callback(new Error('密码不可为空，请填写'));
                } else {
                    callback(new Error('请输入6-20位英文、数字、符号（如$、*、%...）'));
                }
                callback(new Error(''));
            } else {
                if (this.revisepwdform.passwords !== '') {
                    // 对第二个密码框单独验证
                    this.$refs.revisepwdform.validateField('passwords');
                }
                callback();
            }
        };
        const passwordsPass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('确认密码不可为空，请填写'));
            } else if (value !== this.revisepwdform.passwords) {
                callback(new Error('两次输入的密码不一致请重新输入'));
            } else {
                callback();
            }
        };
        return {
            pwdmodal: false, // 修改密码弹窗是否显示
            pwdtxt: '获取验证码', // 获取验证码文案
            pwddisabled: false, // 是否禁用获取验证码按钮
            accountsform: { // 主界面信息
                account: '', // 客户账号
                linkman: '', //联系人
                contactphone: '', // 联系电话 - 隐藏中间为*
                truephone: '', // 联系电话 - 显示完全
                email: '', // 邮箱
                name: '', // 公司名称
                city: '', // 所在地区
                addressdet: '', // 详细地址
                billtitle: '', // 发票抬头
                billnumber: '', // 纳税人识别号
                regaddress: '', // 注册地址
                regphone: '', // 注册电话
                bankname: '', // 开户银行
                banknumber: '', // 银行账号
            },
            accountsrule: { // 主界面信息验证
                linkman: [{required: true, trigger: 'blur'}],
                contactphone: [{required: true, trigger: 'blur'}],
                addressdet: [{required: true, trigger: 'blur'}],
            },
            revisepwdform: { // 修改密码弹窗信息
                account: '', // 客户账号
                verification: '', // 验证码
                password: '', // 密码
                passwords: '', // 重复密码
            },
            revisepwdrule: { // 修改密码弹窗信息验证
                verification: [{required: true, message: '验证码为必填项，请填写', trigger: 'blur'}],
                password: [{validator: passwordPass, required: true, trigger: 'blur'}],
                passwords: [{validator: passwordsPass, required: true, trigger: 'blur'}],
            }
        }
    },
    methods: {
        getInfo () { // 获取信息
            this.http.post(api.accounts)
            .then(response => {
                console.log(response.data.msg)
                this.accountsform.account = this.revisepwdform.account = response.data.msg.customer.account
                this.accountsform.linkman = response.data.msg.customer.linkman
                this.accountsform.contactphone = response.data.msg.customer.contactphone
                this.accountsform.truephone = response.data.msg.customer.truephone
                this.accountsform.email = response.data.msg.customer.email
                this.accountsform.name = response.data.msg.customer.name
                this.accountsform.city = (response.data.msg.customer.sheng_value != '' && response.data.msg.customer.sheng_value != null ? response.data.msg.customer.sheng_value : '') + (response.data.msg.customer.shi_value != '' && response.data.msg.customer.shi_value != null ? response.data.msg.customer.shi_value : '') + (response.data.msg.customer.xian_value != '' && response.data.msg.customer.xian_value != undefined ? response.data.msg.customer.xian_value : '')
                this.accountsform.addressdet = response.data.msg.customer.addressdet
                this.accountsform.billtitle = response.data.msg.customer.billtitle
                this.accountsform.billnumber = response.data.msg.customer.billnumber
                this.accountsform.regaddress = response.data.msg.customer.regaddress
                this.accountsform.regphone = response.data.msg.customer.regphone
                this.accountsform.bankname = response.data.msg.customer.bankname
                this.accountsform.banknumber = response.data.msg.customer.banknumber
            })
            .catch(error => {
                this.noLogin(error)
            })
        },
        reviseInfoSubmit () { // 提交修改信息
            this.http.post(api.accountsrevise,
                {
                    i_linkman: this.accountsform.linkman,
                    i_contactphone: this.accountsform.truephone,
                    i_email: this.accountsform.email,
                    i_addressdet: this.accountsform.addressdet,
                    i_billtitle: this.accountsform.billtitle,
                    i_billnumber: this.accountsform.billnumber,
                    i_regaddress: this.accountsform.regaddress,
                    i_regphone: this.accountsform.regphone,
                    i_bankname: this.accountsform.bankname,
                    i_banknumber: this.accountsform.banknumber,
                }
            )
            .then(response => {
                // console.log(response.data.msg)
                if (!response.data.error) {
                    this.$Message.success(response.data.msg)
                    this.getInfo()
                } else {
                    this.$Message.error(response.data.msg)
                }
            })
            .catch(error => {
                this.$Message.error(error);
            })
        },
        confirmClick () { // 提交修改信息
            this.$refs.accountsform.validate((valid) => {
                if (valid) {
                    this.reviseInfoSubmit()
                } else {
                    this.$Message.error('*标信息为必填项，请填写!');
                }
            })
        },
        orderjump (sign) { // 跳转页面
            let link
            if (sign == 1) {
                link = '/Accounts'
            } else if (sign == 2) {
                link = '/Address'
            } else {
                link = '/MyCoupon'
            }
            this.$router.push(link)
        },
        reviseClick () { // 打开修改密码弹窗
            this.pwdmodal = true
        },
        getVerification () { // 获取验证码
            this.http.post(api.accountsverification, {phone: this.revisepwdform.account})
            .then(response => {
                console.log(response.data.msg.code)
                if (response.data.error) {
                    this.$Message.error(response.data.msg)
                }
            })
            .catch(error => {
                this.$Message.error(error);
            })
        },
        verificationbtn () { // 点击获取验证码按钮
            let clearInter
            let timesign = 60

            if (!this.pwddisabled) {
                this.pwddisabled = true
                this.getVerification()
                clearInter = setInterval(() => {
                    timesign--
                    this.pwdtxt = timesign + 's'
                    if (timesign <= 0) {
                        this.pwddisabled = false
                        this.pwdtxt = '重新获取验证码'
                        clearInterval(clearInter)
                    }
                }, 1000)
            }
        },
        revisepwdsubmit () { // 提交修改密码
            this.http.post(api.accountrevisepwd,
                {
                    i_account: this.revisepwdform.account,
                    i_phonecode: this.revisepwdform.verification,
                    i_password: this.revisepwdform.password,
                    i_repassword: this.revisepwdform.passwords,
                }
            )
            .then(response => {
                console.log(response.data.msg)
                if (!response.data.error) {
                    this.pwdmodal = false
                    this.$Message.success(response.data.msg)
                    this.getInfo()
                } else {
                    this.$Message.error(response.data.msg)
                }
            })
            .catch(error => {
                this.$Message.error(error);
            })
        },
        pwdOk () { // 确认修改密码
            this.$refs.revisepwdform.validate((valid) => {
                if (valid) {
                    this.revisepwdsubmit()
                }
            })
        },
        countactphoneChange (e) { // 修改帐号手机号码时，赋值
            this.accountsform.truephone = e.target.value
        }
    },
    created () {
        this.getInfo()
    }
}
</script>

<style scoped>

.accounts_main {
    padding: 0 10px;
}

.homepage_module_content {
    margin-left: 10px;
    margin-right: 10px;
}

.accounts_list {
    padding: 20px 10px 0 0;
}

.accounts_list .ivu-form-item,
.revisepwd_content .ivu-form-item {
    margin-bottom: 19px;
}

.accounts_txt > span {
    font-size: 14px;
    color: #333;
}

.accounts_txt > a {
    margin-left: 10px;
    font-size: 14px;
    color: #FF8000;
}

.revisepwd_content {
    padding: 0 20px;
}

.confirm_btn_content {
    padding: 40px 10px 20px;
    text-align: right;
}

.confirm_btn_content > button {
    width: 108px;
    height: 44px;
    line-height: 32px;
    font-size: 16px;
}

.revisepwd_verification {
    position: relative;
}

.revisepwd_verification > button {
    min-width: 92px;
    height: 30px;
    line-height: 18px;
    position: absolute;
    right: 1px;
    top: 2px;
    z-index: 1;
}

</style>


// WEBPACK FOOTER //
// src/components/views/member/accounts.vue